module.exports = __webpack_public_path__ + "img/faq-dots.fd755a3b.svg";